// 1K to OK — counter count-up + progress bar reveal
(function () {
  function animateCount(el, target, duration) {
    var start = null;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters() {
    document.querySelectorAll('[data-oktp-countup]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-oktp-countup'), 10) || 0;
      if (el.dataset.oktpAnimated) return;
      el.dataset.oktpAnimated = 'true';
      animateCount(el, target, 1400);
    });
  }

  function initProgressBars() {
    var bars = document.querySelectorAll('[data-oktp-progress-fill]');
    if (!('IntersectionObserver' in window)) {
      bars.forEach(function (el) { el.style.width = el.getAttribute('data-oktp-progress-fill'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var width = el.getAttribute('data-oktp-progress-fill');
          el.style.width = '0%';
          requestAnimationFrame(function () {
            el.style.transition = 'width .9s cubic-bezier(.22,.9,.35,1)';
            el.style.width = width;
          });
          observer.unobserve(el);
        }
      });
    }, { threshold: .3 });
    bars.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCounters();
    initProgressBars();
  });
  document.addEventListener('shopify:section:load', function () {
    initCounters();
    initProgressBars();
  });
})();
